import { createGlobalInstance, getGlobalInstance } from '@/utils/state'

import { WebAppState } from './WebAppState'

export let webAppState: WebAppState = getGlobalInstance('webAppState')

export const initWebAppState = (state: WebAppState) => {
    webAppState = createGlobalInstance('webAppState', () => state)
}

export * from './WebAppState'
export * from './Notifications'
export * from './WatchCounters'
